export default __webpack_public_path__ + "static/media/蘇炫榮.b9e1a17b.jpg";